<div class="ttm-page-title-row" style="background: #293649 url(/assets/images/bg-image/guided-search-updated-banner.jpg) no-repeat bottom right;">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<div class="title-box text-center">
					<div class="page-title-heading">
						<h1 class="title" style="color:white">{{ job?.title || 'Job Details' }}</h1>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="ttm-row">
	<div class="container">
		<div *ngIf="loading" class="loading-spinner">
			<div class="spinner-border text-primary" role="status">
				<span class="visually-hidden">Loading job details...</span>
			</div>
		</div>
		<div *ngIf="error" class="alert alert-danger">{{ error }}</div>

		<ng-container *ngIf="job as j">
			<div class="row">
				<div class="col-lg-8">
					<div class="job-header-card">
						<h1 class="job-title">{{ j.title }}</h1>
					</div>

					<!-- Job Information Card -->
					<div class="job-info-card">
						<h3 class="card-title">Job Information</h3>
						<div class="info-grid">
							<div class="info-item">
								<span class="info-label">Job Type</span>
								<span class="info-value">{{ j.job_type || j.employment_type || 'Not specified' }}</span>
							</div>
							<div class="info-item">
								<span class="info-label">Location</span>
								<span class="info-value">{{ j.job_location || 'Not specified' }}</span>
							</div>
							<div class="info-item" *ngIf="j.candidate_location">
								<span class="info-label">Work Mode</span>
								<span class="info-value">{{ j.candidate_location }}</span>
							</div>
							<div class="info-item" *ngIf="j.required_exp">
								<span class="info-label">Experience</span>
								<span class="info-value">{{ j.required_exp }}</span>
							</div>
							<div class="info-item">
								<span class="info-label">Department</span>
								<span class="info-value">{{ j.department || 'Not specified' }}</span>
							</div>
							<div class="info-item" *ngIf="j.salary_fig && j.salary_currency">
								<span class="info-label">Salary</span>
								<span class="info-value">{{ j.salary_currency }} {{ j.salary_fig | number }}</span>
							</div>
							<div class="info-item" *ngIf="j.salary_compensation && !j.salary_fig">
								<span class="info-label">Salary</span>
								<span class="info-value">{{ j.salary_compensation }}</span>
							</div>
							<div class="info-item" *ngIf="!j.salary_compensation && !j.salary_fig">
								<span class="info-label">Salary</span>
								<span class="info-value">Negotiable</span>
							</div>
							<div class="info-item">
								<span class="info-label">Industry</span>
								<span class="info-value">IT Services</span>
							</div>
						</div>
					</div>

					<!-- Job Summary Card -->
					<div class="job-description-card" *ngIf="j.shortd">
						<h3 class="card-title">Job Summary</h3>
						<div class="description-content">{{ j.shortd }}</div>
					</div>

					<!-- Job Description Card -->
					<div class="job-description-card">
						<h3 class="card-title">Job Description</h3>
						<div class="description-content" [innerHTML]="j.longd || j.shortd || 'Job description not available.'"></div>
					</div>

					<!-- Additional Details Cards -->
					<div class="job-details-card" *ngIf="j.responsibilities && j.responsibilities.length > 0">
						<h3 class="card-title">Key Responsibilities</h3>
						<ul class="detail-list">
							<li *ngFor="let responsibility of j.responsibilities">{{ responsibility }}</li>
						</ul>
					</div>

					<div class="job-details-card" *ngIf="j.requirements && j.requirements.length > 0">
						<h3 class="card-title">Requirements</h3>
						<ul class="detail-list">
							<li *ngFor="let requirement of j.requirements">{{ requirement }}</li>
						</ul>
					</div>

					<div class="job-details-card" *ngIf="j.skills && j.skills.length > 0">
						<h3 class="card-title">Required Skills</h3>
						<ul class="detail-list">
							<li *ngFor="let skill of j.skills">{{ skill }}</li>
						</ul>
					</div>
				</div>

				<div class="col-lg-4">
					<div class="application-card">
						<h2 class="application-title">Apply for this position</h2>
						<form [formGroup]="applicationForm" (ngSubmit)="submitApplication()" novalidate>
							<div class="form-group">
								<label class="form-label">First Name *</label>
								<input 
									type="text" 
									class="form-control" 
									formControlName="firstName"
									placeholder="Enter your first name" 
									[class.is-invalid]="firstName?.invalid && firstName?.touched"
								/>
								<div class="form-error" *ngIf="firstName?.invalid && firstName?.touched">
									<div *ngIf="firstName?.errors?.['required']">First name is required</div>
								</div>
							</div>

							<div class="form-group">
								<label class="form-label">Last Name *</label>
								<input 
									type="text" 
									class="form-control" 
									formControlName="lastName"
									placeholder="Enter your last name" 
									[class.is-invalid]="lastName?.invalid && lastName?.touched"
								/>
								<div class="form-error" *ngIf="lastName?.invalid && lastName?.touched">
									<div *ngIf="lastName?.errors?.['required']">Last name is required</div>
								</div>
							</div>

							<div class="form-group">
								<label class="form-label">Email Address *</label>
								<input 
									type="email" 
									class="form-control" 
									formControlName="email"
									placeholder="Enter your email address" 
									[class.is-invalid]="email?.invalid && email?.touched"
								/>
								<div class="form-error" *ngIf="email?.invalid && email?.touched">
									<div *ngIf="email?.errors?.['required']">Email is required</div>
									<div *ngIf="email?.errors?.['email']">Please enter a valid email address</div>
								</div>
							</div>

							<div class="form-group">
								<label class="form-label">Phone Number *</label>
								<input 
									type="tel" 
									class="form-control" 
									formControlName="phone"
									placeholder="Enter your phone number" 
									[class.is-invalid]="phone?.invalid && phone?.touched"
								/>
								<div class="form-error" *ngIf="phone?.invalid && phone?.touched">
									<div *ngIf="phone?.errors?.['required']">Phone number is required</div>
									<div *ngIf="phone?.errors?.['minlength']">Phone number must be at least 10 digits</div>
								</div>
							</div>

							<div class="form-group">
								<label class="form-label">Upload Resume *</label>
								<div class="file-input-wrapper">
									<input 
										type="file" 
										class="file-input" 
										id="resumeFile"
										(change)="onResumeSelected($event)" 
										accept=".pdf,.doc,.docx" 
									/>
									<label class="file-input-label">
										<i class="ri-upload-cloud-2-line"></i>
										Choose Resume File (PDF, DOC, DOCX)
									</label>
								</div>
								<div class="file-selected" *ngIf="resume?.value">File selected</div>
								<div class="form-error" *ngIf="resume?.invalid && resume?.touched">
									<div *ngIf="resume?.errors?.['required']">Resume is required</div>
								</div>
							</div>

							<button type="submit" class="btn-apply" [disabled]="submitting || applicationForm.invalid">
								<span *ngIf="!submitting">Submit Application</span>
								<span *ngIf="submitting">
									<i class="spinner-border spinner-border-sm me-2" role="status"></i>
									Submitting...
								</span>
							</button>
						</form>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>
